import { createRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
import { ErrorComponent } from '@/ui/ErrorComponent'
import { Loading } from '@/ui/Loading'
import { DataGridComponent } from '../../DataGrid/DataGridComponent'
import '../WorkspaceDetailsPanel.scss'
import { workspaceEntitiesTableColumns } from './worspaceEntitiesTableColumns'

export const WorkspaceEntitiesPanel = () => {
  const { getWorkspacesApiGetOrganisationWorkspaceEntities } = createRestClient()
  const workspaceId = useGetSearchParam<number>('subscriptionId')

  const {
    data: entities,
    isPending,
    isError,
  } = getWorkspacesApiGetOrganisationWorkspaceEntities.useQuery(
    {
      query: { workspaceId },
    },
    { enabled: !!workspaceId }
  )

  if (isPending) return <Loading />
  if (isError) return <ErrorComponent />

  return (
    <>
      <DataGridComponent items={entities} columns={workspaceEntitiesTableColumns} heightAdjustment={90} />
    </>
  )
}
